var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "markForm",
              attrs: {
                model: _vm.markForm,
                "label-width": "40px",
                size: "mini",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.mark_field"), prop: "fieldId" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        placeholder:
                          _vm.$t("commons.please_select") +
                          _vm.$t("chart.mark_field"),
                      },
                      on: { change: _vm.changeFields },
                      model: {
                        value: _vm.markForm.fieldId,
                        callback: function ($$v) {
                          _vm.$set(_vm.markForm, "fieldId", $$v)
                        },
                        expression: "markForm.fieldId",
                      },
                    },
                    _vm._l(_vm.fieldOptions, function (group) {
                      return _c(
                        "el-option-group",
                        { key: group.label, attrs: { label: group.label } },
                        _vm._l(group.options, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.name,
                              value: item.id,
                              disabled: item.disabled,
                            },
                          })
                        }),
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.markForm.conditions, function (condition, index) {
                return _c(
                  "el-form-item",
                  {
                    key: index,
                    staticClass: "form-item",
                    attrs: { label: _vm.$t("chart.mark_value") },
                  },
                  [
                    _c(
                      "el-col",
                      { staticClass: "col-start", attrs: { span: 6 } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            on: {
                              change: function ($event) {
                                return _vm.changeMarkAttr("conditions")
                              },
                            },
                            model: {
                              value: condition.calc,
                              callback: function ($$v) {
                                _vm.$set(condition, "calc", $$v)
                              },
                              expression: "condition.calc",
                            },
                          },
                          _vm._l(_vm.currentCalcOption, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    condition.calc === "between"
                      ? _c(
                          "el-col",
                          { staticClass: "col-center", attrs: { span: 10 } },
                          [
                            _c("el-input", {
                              staticClass: "number-range-input",
                              attrs: { placeholder: "" },
                              on: {
                                input: function ($event) {
                                  return _vm.changeMarkAttr("conditions")
                                },
                              },
                              model: {
                                value: condition.startv,
                                callback: function ($$v) {
                                  _vm.$set(condition, "startv", $$v)
                                },
                                expression: "condition.startv",
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "number-range-span",
                                staticStyle: { padding: "0 2px" },
                              },
                              [_vm._v("-")]
                            ),
                            _c("el-input", {
                              staticClass: "number-range-input",
                              attrs: { placeholder: "" },
                              on: {
                                input: function ($event) {
                                  return _vm.changeMarkAttr("conditions")
                                },
                              },
                              model: {
                                value: condition.endv,
                                callback: function ($$v) {
                                  _vm.$set(condition, "endv", $$v)
                                },
                                expression: "condition.endv",
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "el-col",
                          { staticClass: "col-center", attrs: { span: 10 } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "" },
                              on: {
                                input: function ($event) {
                                  return _vm.changeMarkAttr("conditions")
                                },
                              },
                              model: {
                                value: condition.value,
                                callback: function ($$v) {
                                  _vm.$set(condition, "value", $$v)
                                },
                                expression: "condition.value",
                              },
                            }),
                          ],
                          1
                        ),
                    _c(
                      "el-col",
                      { staticClass: "col-center", attrs: { span: 6 } },
                      [
                        _c("de-icon-group-picker", {
                          attrs: {
                            options: _vm.iconOptions,
                            color: condition.color,
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeMarkAttr("conditions")
                            },
                            "set-color": function (c) {
                              _vm.setConditionColor(index, c)
                            },
                          },
                          model: {
                            value: condition.icon,
                            callback: function ($$v) {
                              _vm.$set(condition, "icon", $$v)
                            },
                            expression: "condition.icon",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticClass: "col-end", attrs: { span: 2 } },
                      [
                        _c("div", [
                          _vm.markForm.conditions.length > 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "i-row-container",
                                  class:
                                    index === _vm.markForm.conditions.length - 1
                                      ? "flex-column"
                                      : "",
                                },
                                [
                                  _c("i", {
                                    staticClass: "ope-item el-icon-minus",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.del(index)
                                      },
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          index === _vm.markForm.conditions.length - 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "i-row-container",
                                  class:
                                    _vm.markForm.conditions.length > 1
                                      ? "flex-column"
                                      : "",
                                },
                                [
                                  _c("i", {
                                    staticClass: "ope-item el-icon-plus",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.add($event)
                                      },
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }